import { render, staticRenderFns } from "./modal-dialog.vue?vue&type=template&id=20226e5b&scoped=true&"
import script from "./modal-dialog.vue?vue&type=script&lang=js&"
export * from "./modal-dialog.vue?vue&type=script&lang=js&"
import style0 from "./modal-dialog.vue?vue&type=style&index=0&id=20226e5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20226e5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
